// react-router v5 מסמן POP גם ברענון (F5) וגם ב-back/forward אמיתי בדפדפן -
// אין דרך להבדיל ביניהם ישירות מ-history.action. הפתרון: דגל ב-sessionStorage
// שמסומן "פעיל" כל עוד ה-tab הזה חי, ונמחק רק ב-beforeunload (שיורה גם
// ברענון וגם בסגירת טאב, אבל לא בניווט SPA רגיל בתוכה). כך: אם הדגל חסר
// כשקוד ה-app עולה מחדש - זו טעינה טרייה (רענון/URL חדש), לא POP אמיתי.
const FLAG_KEY = "__spaSessionActive";

window.addEventListener("beforeunload", () => {
    sessionStorage.removeItem(FLAG_KEY);
});

export const markNavigated = () => {
    sessionStorage.setItem(FLAG_KEY, "1");
}

// true אם ה-tab הזה כבר "חי" (לא טעינה טרייה של ה-JS - כלומר לא רענון/URL חדש)
export const isFreshPageLoad = () => !sessionStorage.getItem(FLAG_KEY);
